export default __webpack_public_path__ + "static/media/nutritionfacts@3x.9e7180b3.jpg";